const BaseService = require('./abstract/base');

module.exports = {
  BaseService,
};
